const Particles3 = ({ sx }) => {
  const _sx = sx ?? {};
  return (
    <svg
      style={_sx}
      width="382"
      height="241"
      viewBox="0 0 382 241"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <line
          x1="134.277"
          y1="130.81"
          x2="195.196"
          y2="90.5747"
          stroke="white"
          strokeOpacity="0.89"
        />
        <line
          x1="376.074"
          y1="178.941"
          x2="347.995"
          y2="100.637"
          stroke="white"
          strokeOpacity="0.89"
        />
        <line
          x1="348.029"
          y1="100.712"
          x2="290.103"
          y2="-2.77521"
          stroke="white"
          strokeOpacity="0.89"
        />
        <line
          x1="193.003"
          y1="91.3657"
          x2="189.724"
          y2="26.9511"
          stroke="white"
          strokeOpacity="0.89"
        />
        <line
          x1="245.049"
          y1="-55.5504"
          x2="189.02"
          y2="29.5187"
          stroke="white"
          strokeOpacity="0.89"
        />
        <line
          x1="190.353"
          y1="29.3449"
          x2="97.0061"
          y2="-16.0787"
          stroke="white"
          strokeOpacity="0.89"
        />
        <line
          x1="98.2326"
          y1="-13.6969"
          x2="135.56"
          y2="134.058"
          stroke="white"
          strokeOpacity="0.89"
        />
        <line
          x1="134.063"
          y1="131.125"
          x2="143.943"
          y2="83.6764"
          stroke="white"
          strokeOpacity="0.89"
        />
        <line
          x1="144.05"
          y1="83.4566"
          x2="190.189"
          y2="28.5735"
          stroke="white"
          strokeOpacity="0.89"
        />
        <line
          x1="143.98"
          y1="83.9912"
          x2="96.7725"
          y2="-16.3154"
          stroke="white"
          strokeOpacity="0.89"
        />
        <line
          x1="141.566"
          y1="83.8089"
          x2="196.081"
          y2="93.4536"
          stroke="white"
          strokeOpacity="0.89"
        />
        <line
          x1="193.536"
          y1="90.8415"
          x2="350.818"
          y2="101.589"
          stroke="white"
          strokeOpacity="0.89"
        />
        <line
          x1="348.262"
          y1="100.924"
          x2="188.399"
          y2="29.7004"
          stroke="white"
          strokeOpacity="0.89"
        />
        <line
          x1="190.43"
          y1="28.4158"
          x2="292.715"
          y2="-1.87787"
          stroke="white"
          strokeOpacity="0.89"
        />
        <circle
          cx="189.587"
          cy="29.0698"
          r="4"
          transform="rotate(-100.039 189.587 29.0698)"
          fill="white"
        />
        <circle
          cx="189.587"
          cy="29.0698"
          r="4"
          transform="rotate(-100.039 189.587 29.0698)"
          fill="white"
        />
        <circle
          cx="189.587"
          cy="29.0698"
          r="4"
          transform="rotate(-100.039 189.587 29.0698)"
          fill="white"
        />
        <circle
          cx="189.587"
          cy="29.0698"
          r="4"
          transform="rotate(-100.039 189.587 29.0698)"
          fill="white"
        />
        <circle
          cx="189.587"
          cy="29.0698"
          r="4"
          transform="rotate(-100.039 189.587 29.0698)"
          fill="white"
        />
        <circle
          cx="189.587"
          cy="29.0698"
          r="3.5"
          transform="rotate(-100.039 189.587 29.0698)"
          stroke="white"
          strokeOpacity="0.89"
        />
        <circle
          cx="290.888"
          cy="-1.04984"
          r="4"
          transform="rotate(-100.039 290.888 -1.04984)"
          fill="white"
        />
        <circle
          cx="290.888"
          cy="-1.04984"
          r="4"
          transform="rotate(-100.039 290.888 -1.04984)"
          fill="white"
        />
        <circle
          cx="290.888"
          cy="-1.04984"
          r="4"
          transform="rotate(-100.039 290.888 -1.04984)"
          fill="white"
        />
        <circle
          cx="290.888"
          cy="-1.04984"
          r="4"
          transform="rotate(-100.039 290.888 -1.04984)"
          fill="white"
        />
        <circle
          cx="290.888"
          cy="-1.04984"
          r="4"
          transform="rotate(-100.039 290.888 -1.04984)"
          fill="white"
        />
        <circle
          cx="290.888"
          cy="-1.04984"
          r="3.5"
          transform="rotate(-100.039 290.888 -1.04984)"
          stroke="white"
          strokeOpacity="0.89"
        />
        <circle
          cx="348.465"
          cy="100.468"
          r="4"
          transform="rotate(-100.039 348.465 100.468)"
          fill="white"
        />
        <circle
          cx="348.465"
          cy="100.468"
          r="4"
          transform="rotate(-100.039 348.465 100.468)"
          fill="white"
        />
        <circle
          cx="348.465"
          cy="100.468"
          r="4"
          transform="rotate(-100.039 348.465 100.468)"
          fill="white"
        />
        <circle
          cx="348.465"
          cy="100.468"
          r="4"
          transform="rotate(-100.039 348.465 100.468)"
          fill="white"
        />
        <circle
          cx="348.465"
          cy="100.468"
          r="4"
          transform="rotate(-100.039 348.465 100.468)"
          fill="white"
        />
        <circle
          cx="348.465"
          cy="100.468"
          r="3.5"
          transform="rotate(-100.039 348.465 100.468)"
          stroke="white"
          strokeOpacity="0.89"
        />
        <circle
          cx="376.545"
          cy="178.772"
          r="4"
          transform="rotate(-100.039 376.545 178.772)"
          fill="white"
        />
        <circle
          cx="376.545"
          cy="178.772"
          r="4"
          transform="rotate(-100.039 376.545 178.772)"
          fill="white"
        />
        <circle
          cx="376.545"
          cy="178.772"
          r="4"
          transform="rotate(-100.039 376.545 178.772)"
          fill="white"
        />
        <circle
          cx="376.545"
          cy="178.772"
          r="4"
          transform="rotate(-100.039 376.545 178.772)"
          fill="white"
        />
        <circle
          cx="376.545"
          cy="178.772"
          r="4"
          transform="rotate(-100.039 376.545 178.772)"
          fill="white"
        />
        <circle
          cx="376.545"
          cy="178.772"
          r="3.5"
          transform="rotate(-100.039 376.545 178.772)"
          stroke="white"
          strokeOpacity="0.89"
        />
        <circle
          cx="192.517"
          cy="91.5149"
          r="4"
          transform="rotate(-100.039 192.517 91.5149)"
          fill="white"
        />
        <circle
          cx="192.517"
          cy="91.5149"
          r="4"
          transform="rotate(-100.039 192.517 91.5149)"
          fill="white"
        />
        <circle
          cx="192.517"
          cy="91.5149"
          r="4"
          transform="rotate(-100.039 192.517 91.5149)"
          fill="white"
        />
        <circle
          cx="192.517"
          cy="91.5149"
          r="4"
          transform="rotate(-100.039 192.517 91.5149)"
          fill="white"
        />
        <circle
          cx="192.517"
          cy="91.5149"
          r="4"
          transform="rotate(-100.039 192.517 91.5149)"
          fill="white"
        />
        <circle
          cx="192.517"
          cy="91.5149"
          r="3.5"
          transform="rotate(-100.039 192.517 91.5149)"
          stroke="white"
          strokeOpacity="0.89"
        />
        <circle
          cx="142.637"
          cy="85.1118"
          r="4"
          transform="rotate(-100.039 142.637 85.1118)"
          fill="white"
        />
        <circle
          cx="142.637"
          cy="85.1118"
          r="4"
          transform="rotate(-100.039 142.637 85.1118)"
          fill="white"
        />
        <circle
          cx="142.637"
          cy="85.1118"
          r="4"
          transform="rotate(-100.039 142.637 85.1118)"
          fill="white"
        />
        <circle
          cx="142.637"
          cy="85.1118"
          r="4"
          transform="rotate(-100.039 142.637 85.1118)"
          fill="white"
        />
        <circle
          cx="142.637"
          cy="85.1118"
          r="4"
          transform="rotate(-100.039 142.637 85.1118)"
          fill="white"
        />
        <circle
          cx="142.637"
          cy="85.1118"
          r="3.5"
          transform="rotate(-100.039 142.637 85.1118)"
          stroke="white"
          strokeOpacity="0.89"
        />
        <circle
          cx="133.568"
          cy="131.402"
          r="4"
          transform="rotate(-100.039 133.568 131.402)"
          fill="white"
        />
        <circle
          cx="133.568"
          cy="131.402"
          r="4"
          transform="rotate(-100.039 133.568 131.402)"
          fill="white"
        />
        <circle
          cx="133.568"
          cy="131.402"
          r="4"
          transform="rotate(-100.039 133.568 131.402)"
          fill="white"
        />
        <circle
          cx="133.568"
          cy="131.402"
          r="4"
          transform="rotate(-100.039 133.568 131.402)"
          fill="white"
        />
        <circle
          cx="133.568"
          cy="131.402"
          r="4"
          transform="rotate(-100.039 133.568 131.402)"
          fill="white"
        />
        <circle
          cx="133.568"
          cy="131.402"
          r="3.5"
          transform="rotate(-100.039 133.568 131.402)"
          stroke="white"
          strokeOpacity="0.89"
        />
      </g>
    </svg>
  );
};

export default Particles3;
